import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { useInactivityLogout } from "../lib/inactivity";
import { toast } from "sonner";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    // null = checking; false = anonymous; object = user
    const [user, setUser] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/auth/me");
                setUser(data);
            } catch {
                setUser(false);
            }
        })();
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        if (data.token) localStorage.setItem("stock_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const register = async (name, email, password) => {
        const { data } = await api.post("/auth/register", { name, email, password });
        if (data.token) localStorage.setItem("stock_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (err) {
            console.warn("Logout request failed:", err?.message || err);
        }
        localStorage.removeItem("stock_token");
        setUser(false);
    };

    // Auto logout after 2h of inactivity (only when logged in)
    useInactivityLogout(!!user, async () => {
        await logout();
        toast.info("已闲置超过 2 小时，为了安全已自动登出。请重新登录。", { duration: 8000 });
    });

    return (
        <AuthContext.Provider value={{ user, setUser, login, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
